import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const getAlbums = () => api.get("/albums").then((r) => r.data);
export const getSongs = (album) =>
  api.get("/songs", { params: album ? { album } : {} }).then((r) => r.data);
export const getSong = (slug) => api.get(`/songs/${slug}`).then((r) => r.data);
export const submitContact = (payload) =>
  api.post("/contact", payload).then((r) => r.data);
export const subscribeNewsletter = (payload) =>
  api.post("/newsletter", payload).then((r) => r.data);
export const submitLicensing = (payload) =>
  api.post("/licensing-inquiry", payload).then((r) => r.data);
